/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Metadata for required work that reached a typed non-retryable failure.
 */
export type EmployeeExecutionTerminalOperationFailureBlocker = {
    /**
     * Deterministic blocker classification.
     */
    category: EmployeeExecutionTerminalOperationFailureBlocker.category;
    /**
     * Sanitized human-readable explanation without raw tool output.
     */
    reason: string;
    /**
     * Structured operation kind that cannot continue safely.
     */
    operationKind: string;
    /**
     * Tool that returned the typed terminal failure.
     */
    toolName: string;
    /**
     * ISO timestamp when the runtime determined that progress was blocked.
     */
    occurredAt: string;
};
export namespace EmployeeExecutionTerminalOperationFailureBlocker {
    /**
     * Deterministic blocker classification.
     */
    export enum category {
        TERMINAL_OPERATION_FAILURE = 'terminal-operation-failure',
    }
}

